document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".sticky-atc-bar.hidden");
  const badges = document.querySelector(".product__primary-right .product-badges"); 
  const mainProduct = document.querySelector(".main-product-section"); 
  const mediaContainer = document.querySelector(".product__media-container"); 
  const recommended = document.querySelector(".recommended-products"); 
  const backToTop = document.querySelector(".back-to-top");
  const drawer = document.querySelector(".shoppable-feature-mobile-drawer");

  // --- Coming Soon Logik (Detailseite) ---
  const comingSoonButton = document.querySelector('[data-coming-soon="true"]');
  
  if (comingSoonButton) {
    if (badges) {
      badges.style.display = "none";
    }
  }

  // --- Flag um Schleifen zu verhindern ---
  let isEnforcing = false;

  // --- FUNKTION: Coming Soon Button-Status erzwingen ---
  function enforceComingSoonButton() {
    // Verhindere Schleifen
    if (isEnforcing) return;
    isEnforcing = true;

    const comingSoonButtons = document.querySelectorAll('[data-coming-soon="true"]');
    
    comingSoonButtons.forEach(btn => {
      // Button-Type auf "button" setzen
      btn.setAttribute('type', 'button');
      
      // Disabled-Status wiederherstellen
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('disabled', '');
      
      // Coming Soon Text aus aria-label holen und setzen
      const comingSoonText = btn.getAttribute('aria-label')?.trim();
      const textSpan = btn.querySelector('[data-add-to-cart-text]');
      
      if (textSpan && comingSoonText && textSpan.textContent !== comingSoonText) {
        textSpan.textContent = comingSoonText;
      }
      
      // Klasse hinzufügen
      btn.classList.add('coming-soon-active');
      
      // Klicks verhindern
      btn.style.pointerEvents = 'none';
    });

    // Flag nach kurzer Zeit zurücksetzen
    setTimeout(() => {
      isEnforcing = false;
    }, 100);
  }

  // Initial ausführen wenn Coming Soon aktiv
  if (comingSoonButton) {
    enforceComingSoonButton();
  }

  // --- Varianten-Wechsel überwachen (BESSERER ANSATZ) ---
  // Überwache das Product Form direkt
  const productForm = document.querySelector('[data-product-form]');
  
  if (productForm && comingSoonButton) {
    productForm.addEventListener('change', function(e) {
      // Prüfe ob es ein Varianten-Selector ist
      if (e.target.matches('[name="id"], .variant-input, input[type="radio"]')) {
        setTimeout(() => {
          enforceComingSoonButton();
        }, 100);
      }
    });
  }

  // --- VEREINFACHTER MutationObserver (nur für kritische Attribute) ---
  const cartButtons = document.querySelectorAll(".product-form__cart-submit");
  
  cartButtons.forEach(btn => {
    if (btn.hasAttribute('data-coming-soon')) {
      const buttonObserver = new MutationObserver(function(mutations) {
        // Prüfe nur wenn wir nicht gerade selbst Änderungen vornehmen
        if (isEnforcing) return;
        
        // Prüfe ob disabled entfernt wurde oder type geändert wurde
        let needsEnforcement = false;
        
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes') {
            const attrName = mutation.attributeName;
            if (attrName === 'disabled' && !btn.hasAttribute('disabled')) {
              needsEnforcement = true;
            }
            if (attrName === 'type' && btn.getAttribute('type') !== 'button') {
              needsEnforcement = true;
            }
          }
        });
        
        if (needsEnforcement) {
          enforceComingSoonButton();
        }
      });

      // NUR wichtige Attribute beobachten
      buttonObserver.observe(btn, { 
        attributes: true,
        attributeFilter: ['type', 'disabled']
      });
    }
  });

  // --- Text-Änderungen separat beobachten ---
  const addToCartTextSpans = document.querySelectorAll('[data-add-to-cart-text]');
  addToCartTextSpans.forEach(span => {
    const parentButton = span.closest('[data-coming-soon="true"]');
    if (parentButton) {
      const comingSoonText = parentButton.getAttribute('aria-label')?.trim();
      
      const textObserver = new MutationObserver(function(mutations) {
        if (isEnforcing) return;
        
        // Nur wenn Text tatsächlich falsch ist
        if (span.textContent !== comingSoonText) {
          enforceComingSoonButton();
        }
      });
      
      textObserver.observe(span, {
        characterData: true,
        childList: true
      });
    }
  });

  // --- Quick View Coming Soon Logik ---
  document.addEventListener("click", function (e) {
    const quickTrigger = e.target.closest('[data-quick-shop-trigger="quick-view"]');
    if (quickTrigger) {
      setTimeout(() => {
        const quickView = document.querySelector(".quick-product--right");
        if (quickView) {
          const comingSoonButton = quickView.querySelector('[data-coming-soon="true"]');
          if (comingSoonButton) {
            enforceComingSoonButton();
          }
        }
      }, 1000);
    }
  });

  if (!bar && !badges && !backToTop && !drawer) return;

  // --- Scroll-Logik ---
  window.addEventListener("scroll", function () {
    const viewportMiddle = window.innerHeight / 2;
    const isMobile = window.innerWidth < 960;

    if (bar && mainProduct) {
      const rectMain = mainProduct.getBoundingClientRect();
      const shouldHideBar = rectMain.bottom <= viewportMiddle;

      bar.style.transition = "transform 0.3s ease, visibility 0.3s ease";
      if (shouldHideBar) {
        bar.style.transform = "translateY(100%)";
        bar.style.visibility = "hidden";
      } else {
        bar.style.transform = "translateY(0%)";
        bar.style.visibility = "visible";
      }
    }

    if (!comingSoonButton && badges) {
      badges.style.transition = "opacity 0.3s ease";

      if (isMobile && mediaContainer) {
        const rectMedia = mediaContainer.getBoundingClientRect();
        const shouldShowBadges = rectMedia.bottom > 0;

        badges.style.opacity = shouldShowBadges ? "1" : "0";
        badges.style.pointerEvents = shouldShowBadges ? "auto" : "none";
      } else if (!isMobile && recommended) {
        const rectRec = recommended.getBoundingClientRect();
        const shouldShowBadges = rectRec.top > viewportMiddle;

        badges.style.opacity = shouldShowBadges ? "1" : "0";
        badges.style.pointerEvents = shouldShowBadges ? "auto" : "none";
      }
    }
  });

  // --- Beobachten, ob Drawer .active erhält ---
  if (drawer && backToTop) {
    const drawerObserver = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === "class") {
          if (drawer.classList.contains("active")) {
            backToTop.classList.remove("visible");
          } else {
            backToTop.classList.add("visible");
          }
        }
      }
    });
    drawerObserver.observe(drawer, { attributes: true });
  }

  // --- Akkordeon Scroll-Logik mit Offset ---
  const accordions = document.querySelectorAll(".accordion__label");
  accordions.forEach(label => {
    label.addEventListener("click", function () {
      const parent = label.closest(".accordion__inner");
      setTimeout(() => {
        if (parent && (parent.classList.contains("open") || label.getAttribute("aria-expanded") === "true")) {
          const rect = parent.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const offset = 100; 
          window.scrollTo({
            top: rect.top + scrollTop - offset,
            behavior: "smooth"
          });
        }
      }, 300);
    });
  });

  // --- SVG in Wishlist-Buttons ersetzen ---
  function replaceWishlistSVGs(root = document) {
    const selectors = [
      ".wishlisthero-floating.wishlist-hero-custom-button svg",
      "#wishlisthero-product-page-button-container svg"
    ];

    selectors.forEach(sel => {
      const svgs = root.querySelectorAll(sel);
      svgs.forEach(svg => {
        const img = document.createElement("img");
        img.src = "https://cdn.shopify.com/s/files/1/0941/6022/4586/files/hernameis-heart.svg?v=1755716111";
        img.width = 14;
        img.alt = "Herz Icon";
        svg.replaceWith(img);
      });
    });
  }

  replaceWishlistSVGs();

  const wishlistObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches?.(".wishlisthero-floating.wishlist-hero-custom-button, #wishlisthero-product-page-button-container")
        ) {
          replaceWishlistSVGs(node);
        }

        if (node.querySelectorAll) {
          replaceWishlistSVGs(node);
        }
      });
    });
  });

  wishlistObserver.observe(document.body, { childList: true, subtree: true });

});